export default __webpack_public_path__ + "static/media/img_403.9f44544b.svg";